export const AuthenticationDetails = {
    acessTokenTimeout: 2 * 60 * 1000,    // 2 minutes = 120000 ms
    inActivityTimeout: 10 * 60 * 1000    // 10 minutes = 600000 ms
}
